export default __webpack_public_path__ + "static/media/abld_inverted_math.931576116b436d10789d8b09236591e4.svg";